import React from 'react'

const Maintenance = () => {
  return (
    <div className='container-fluid bg-white pt-5 pt-md-0' style={{ minHeight: '90vh' }}>
      <div className='container mt-5 mt-md-0 pt-5 pt-md-0'>
        <div className='row align-items-center h-100 py-5'>
          <div className='col-12 col-md-6'>
            <h2>Olá, estamos trabalhando para melhorar a sua experiência.</h2>
          </div>
          <div className='col-12 col-md-6 pos-relative'>
            <img src='https://s3.amazonaws.com/ltm.ragnarok.tenants.prod.50458/wip-min.png'
              style={{ maxWidth: '100%', maxHeight: '500px' }} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Maintenance



// WEBPACK FOOTER //
// ./src/features/Maintenance/Maintenance.js